function getPercentage(rate) {
  return (rate / 10) * 100;
}

export { getPercentage };
